document.addEventListener('DOMContentLoaded', function() {
  var addToCartBtn = document.getElementById('AddToCart');
  var queryString = window.location.search;
  var productSelector = document.getElementById("product_selector");
  var selectorSpanElement = productSelector ? productSelector.firstElementChild : null;
  var variantButtons = document.querySelectorAll('x-listbox button[role="option"]');
  var productForm = document.querySelector('#product-installment-form-template--19458340782347__main-8552419164427');

  // Handle initial load based on query string
  if (queryString.includes('variant=')) {
      if(addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.innerText = window.themeVariables.strings.addToCartButton;
      }
  } else {
    //  if(addToCartBtn) addToCartBtn.disabled = true;
    if (selectorSpanElement) {
      selectorSpanElement.innerText = window.themeVariables.strings.productFormSelectOption;
    }
  }

  // Add click event listener to each variant button
  if(variantButtons) {
      variantButtons.forEach(function(button) {
        button.addEventListener('click', function(event) {
          var selectedVariantText = button.querySelector('span').innerText;
          var isDisabled = button.classList.contains('is-disabled');
          var variantId = button.getAttribute('data-variant-id'); // Ensure this attribute exists

          // Update the dropdown text
          if (selectorSpanElement) {
            selectorSpanElement.innerText = selectedVariantText;
          }

          // Handle available variant click
          if (!isDisabled) {
            handleAvailableVariant(variantId);
          } else {
            // Handle out-of-stock variant click
            handleOutOfStockVariant(button, selectedVariantText);
          }
        });
      });
  }

  // Function to handle available variants
  function handleAvailableVariant(variantId) {
    if(addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.innerText = window.themeVariables.strings.addToCartButton;
    }

    // Update hidden input with the selected variant value (id)
    if(productForm) {
        var hiddenInput = productForm.querySelector('input[name="id"]'); 
        if (hiddenInput) {
          hiddenInput.value = variantId; 
        }
    }
  }

  // Function to handle out-of-stock variants
  function handleOutOfStockVariant(button, selectedVariantText) {
    if(addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.innerText = "Ausverkauft";
    }

    // Set the waiting list link with the correct variant details
    const variantId = button.getAttribute('data-variant-id');
    const wartelisteLink = document.querySelector('.klaviyo-bis-trigger.button.w-full');
    if (wartelisteLink) {
      wartelisteLink.setAttribute('data-variant-id', variantId);
      wartelisteLink.setAttribute('data-variant-text', selectedVariantText);
      
      // Show the waiting list button if hidden
      wartelisteLink.style.display = 'block'; // Change to block or inline as necessary

      // Use a timeout to ensure visibility before clicking
      setTimeout(() => {
        // Check if the button is visible before clicking
        if (wartelisteLink.offsetParent !== null) { // Check if visible
          wartelisteLink.click();
        } else {
          console.error('Waiting list button is not visible');
        }
      }, 100); // Short delay to ensure it has time to render
    } else {
      console.error('Waiting list button not found');
    }
  }
});